import React from "react";
import Header from "./Header.js";
import { detect } from "detect-browser";

import * as Sentry from "@sentry/browser";
import ReactGA from "react-ga";
import { hotjar } from "react-hotjar";

const sentry_key = APP_CONFIG.sentry_key;
const sentry_app = APP_CONFIG.sentry_app;
const sentry_environment = APP_CONFIG.sentry_env;
const browser = detect();

if (sentry_key && sentry_app) {
  Sentry.init({
    dsn: "https://" + sentry_key + "@sentry.io/" + sentry_app,
    environment: sentry_environment
  });
}

const google_analytics_id = APP_CONFIG.google_analytics_id;
let lastPage = "";

if (google_analytics_id) {
  ReactGA.initialize(google_analytics_id);
}

const hotjar_id = APP_CONFIG.hotjar_id;
if (hotjar_id) {
  hotjar.initialize(hotjar_id, "");
}

// Check the browser first, redirect to a page if this browser is not suported
if (browser && !window.location.href.includes("outdated")) {
  let redirect = false;
  if (browser.name == "ie") {
    redirect = true;
  }
  if (browser.name == "ios" && parseInt(browser.version) < 10) {
    redirect = true;
  }

  if (redirect) {
    window.location = "/outdated";
  }
}

export default class Main extends React.Component {
  componentWillUpdate() {
    let newPage = window.location.pathname + window.location.search;
    if (newPage !== lastPage) {
      lastPage = newPage;
      if (google_analytics_id) {
        ReactGA.pageview(lastPage);
      }
    }
  }

  render() {
    const isLoggedIn = Boolean(this.props.authentication && this.props.authentication.isAuthenticated);
    return (
      <div className="site-container">
        <Header loggedIn={isLoggedIn} logoutRequest={this.props.logoutRequest} />

        <div className="main-container">{React.cloneElement({ ...this.props }.children, { ...this.props })}</div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./components/Main.js